import { ResponseEmailValidate, RequestEmailValidate } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { EmailValidateActions } from '../actions';
import { EmailValidateTypes } from '../../shared/enums';


export interface EmailValidateState {
    response: ResponseEmailValidate;
    request: RequestEmailValidate;
    error: any;
}

export const EmailValidateInitialState: EmailValidateState = {
    response: null,
    request: null,
    error: null
};

const _emailValidateReducer = createReducer(
    EmailValidateInitialState,

    on(EmailValidateActions.getEmailValidate, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(EmailValidateActions.getEmailValidateSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(EmailValidateActions.getEmailValidateError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(EmailValidateActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function emailValidateReducer(state, action) {
    if (action.type === EmailValidateTypes.EMAIL_VALIDATE) {
        state = undefined;
    }
    return _emailValidateReducer(state, action);
}
